const getLegacyStatusCode = (data) =>
  typeof data?.statusCodeValue === "number" ? data.statusCodeValue : null;

const getDashboardBodyError = (body) => {
  if (!body) {
    return null;
  }

  if (typeof body === "string") {
    return body;
  }

  if (typeof body === "object") {
    return body.error || body.message || null;
  }

  return null;
};

export const unwrapDashboardResponse = (
  responseOrData,
  fallbackError = "Dashboard request failed"
) => {
  const data = responseOrData?.data ?? responseOrData;
  const legacyStatusCode = getLegacyStatusCode(data);

  if (legacyStatusCode === null) {
    return data;
  }

  if (legacyStatusCode >= 400) {
    const error = new Error(getDashboardBodyError(data.body) || fallbackError);
    error.statusCode = legacyStatusCode;
    error.body = data.body ?? null;
    throw error;
  }

  return data.body;
};

export const getDashboardErrorMessage = (
  error,
  fallbackError = "Dashboard request failed"
) => {
  const responseData = error?.response?.data;

  if (typeof responseData === "string" && responseData.trim()) {
    return responseData;
  }

  if (responseData && typeof responseData === "object") {
    if (typeof responseData.error === "string" && responseData.error.trim()) {
      return responseData.error;
    }

    const legacyStatusCode = getLegacyStatusCode(responseData);
    if (legacyStatusCode !== null) {
      return getDashboardBodyError(responseData.body) || fallbackError;
    }

    const bodyError = getDashboardBodyError(responseData.body);
    if (bodyError) {
      return bodyError;
    }

    if (typeof responseData.message === "string" && responseData.message.trim()) {
      return responseData.message;
    }
  }

  if (getDashboardBodyError(error?.body)) {
    return getDashboardBodyError(error.body);
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallbackError;
};
